import { Building2, Plus } from "lucide-react";
import Select from "react-select";
import { Button } from "../../../../../components/ui/common/button";
import { Card, CardContent, CardHeader, CardTitle } from "../../../../../components/ui/common/card";
import {
  COMPANY_NAME,
  EYEBROW_CLASS,
  ImpactAssessmentMethodText
} from "../../../../../config/constants";

import { formatClimateValueWithUnit } from "../../../../../utils/scientificNumberView";
import "./matchingCard.scss";

export default function MatchingCard({
  addProductToMain,
  handleSubCompanyChange,
  selectedSubCompany,
  availableProducts,
  subCompany,
  setTenantId,
  productAverageSummaryData
}: any) {
  const climateChangeMeasure = productAverageSummaryData?.climateChange?.measure || 0;
  const climateChangeUnit = productAverageSummaryData?.climateChange?.unit || "";
  const climateChangeMeasureValue = formatClimateValueWithUnit({
    value: climateChangeMeasure
  })?.toString();
  const isClimateChangesEmpty = !productAverageSummaryData?.climateChange;

  return (
    <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-6 tw-mb-8">
      <Card className="tw-border tw-rounded-tl-lg tw-rounded-tr-lg tw-p-0">
        <CardHeader className="tw-bg-main-background tw-border tw-rounded-tl-lg tw-rounded-tr-lg tw-p-1">
          <CardTitle className={`tw-flex tw-items-center ${EYEBROW_CLASS}`}>
            <Building2 className="tw-w-5 tw-h-5 tw-mr-0 tw-py-4" />
            Sub Company
          </CardTitle>
        </CardHeader>
        <CardContent className="tw-p-1 tw-px-5">
          <Select
            value={selectedSubCompany}
            onChange={(e: any) => {
              const tenantId = e?.tenantId;
              handleSubCompanyChange(e);
              setTenantId(tenantId);
            }}
            options={subCompany}
          />
          {selectedSubCompany ? (
            <div className="tw-mt-1 tw-p-1 tw-bg-main-card-background tw-rounded-lg">
              <p className="tw-text-sm tw-text-main-card-color tw-font-medium tw-mb-0">
                {selectedSubCompany.label}
              </p>
              <p className="tw-text-xs tw-text-main-card-color tw-mt-0">
                {selectedSubCompany?.address}
              </p>
            </div>
          ) : null}
        </CardContent>
      </Card>

      <Card className="tw-border tw-rounded-tl-lg tw-rounded-tr-lg tw-p-0">
        <CardHeader className="tw-bg-main-background tw-border tw-rounded-tl-lg tw-rounded-tr-lg tw-p-1">
          <CardTitle className={`tw-flex tw-items-center tw-py-2 tw-px-5 ${EYEBROW_CLASS}`}>
            Available Products
          </CardTitle>
        </CardHeader>
        <CardContent className="tw-p-1 tw-max-h-75 tw-overflow-y-auto tw-mb-1 tw-px-5">
          <div className="tw-space-y-1">
            {availableProducts && availableProducts.length > 0 ? (
              availableProducts.map((product: any) => (
                <div
                  key={product.id}
                  className="tw-flex tw-items-center tw-justify-between tw-p-1 tw-bg-main-card-background tw-rounded-lg"
                >
                  <div>
                    <p className="tw-text-sm tw-font-medium tw-text-main-card-color tw-mb-0">
                      {product?.productName}
                    </p>
                    <p className="tw-text-xs tw-text-main-card-color tw-mt-0">
                      {product?.salesUnitName}
                    </p>
                  </div>
                  <Button
                    size="icon"
                    onClick={() => addProductToMain(product)}
                    type="button"
                    className="tw-h-auto tw-w-auto tw-p-1.5"
                  >
                    <Plus className="tw-w-3 tw-h-3" />
                  </Button>
                </div>
              ))
            ) : (
              <p className="tw-text-sm tw-text-main-card-color tw-italic">
                Product is not available
              </p>
            )}
          </div>
        </CardContent>
      </Card>

      <Card className="tw-border tw-rounded-tl-lg tw-rounded-tr-lg tw-p-0">
        <CardHeader className="tw-bg-main-background tw-border tw-rounded-tl-lg tw-rounded-tr-lg tw-p-1">
          <CardTitle className={`tw-flex tw-items-center tw-py-2 tw-px-5 ${EYEBROW_CLASS}`}>
            Climate Change Impact
          </CardTitle>
        </CardHeader>
        <CardContent className="tw-p-1 tw-max-h-100 tw-overflow-y-auto tw-mb-1 tw-px-5">
          {!isClimateChangesEmpty ? (
            <div className="tw-space-y-2">
              <p className="productMatchingNumberOfClimate">{climateChangeMeasureValue}</p>
              <p className="productMatchingNumberOfClimateSub">{climateChangeUnit + " per kg"}</p>
              <div className="productMatchingClimateDetailsView">
                {COMPANY_NAME}
                {ImpactAssessmentMethodText}
              </div>
            </div>
          ) : (
            <div className="productMatchingClimateDetailsView">
              Climate change impact details are currently unavailable.
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
